/* Homepage Instagram Feed */

$(document).ready(function() {
  $('.ar-instagram-feed').closest('.shopify-section').addClass('has-instagram-feed');
});


/* Homepage FAQ */

document.addEventListener('DOMContentLoaded', function () {
    const faqSections = document.querySelectorAll('.ar-faq');
    faqSections.forEach(section => {
        const questions = section.querySelectorAll('.question-container');
        questions.forEach(question => {
            const toggleIcon = question.querySelector('i.fa');
            question.addEventListener('click', function () {
                const answer = this.nextElementSibling;
                const isActive = answer.classList.contains('active');

                closeAllAnswers(section);

                if (!isActive) {
                    answer.classList.add('active');
                    toggleIcon.style.transform = 'rotate(180deg)';
                } else {
                    answer.classList.remove('active');
                    toggleIcon.style.transform = 'rotate(0deg)';
                }
            });
        });
    });

    function closeAllAnswers(section) {
        const answers = section.querySelectorAll('.answer-container');
        answers.forEach(answer => {
            answer.classList.remove('active');
        });
    }
});

$(document).ready(function() {
  $('.ar-faq').closest('.shopify-section').addClass('has-faq');
});

var sections = document.querySelectorAll('.shopify-section');

sections.forEach(function(section) {
    if (section.querySelector('.ar-faq')) {
        section.style.marginTop = '0px';
    }
});

